import { Input } from 'antd';
import React, { Component } from 'react';
import './styles.css';

/**
 * vs 1.0.4
 * @param string validate : message hiển thị khi validate fail
 * @param array decimal : [<số chữ số trước dấu phẩy động>, <số chữ số sau dấu phẩy động>]
 * @param props isSeparate Có phân cách hàng nghìn hay không
 * @param number defaultValue: giá trị mặc định nếu không nhập
 * @param boolean isRedstar: nếu = false ân * , không thì show *
 * @param string addonBefore: nếu có addonBefore show input có thuộc tính addonBefore , không thì show addonBefore
 * @param number min: số được nhập nhỏ nhất
 * @param boolean disabled nếu disabled===true thì input chặn nhập, default false
 */

class InputFormat extends Component {
    constructor(props) {
        super(props);
        let value = props.value ? props.value : undefined
        this.state = {
            valueFormat: InputFormat.formatNumber(value, props.isSeparate, 0, props.allowNegative),
            error: '',
            valuePublic: Number(InputFormat.parserNumber(props.value)),
            prefixIsZero: this.props.prefixIsZero ? true : false
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(JSON.stringify(InputFormat.formatNumber(nextProps.value, nextProps.isSeparate, 0, nextProps.allowNegative)) === JSON.stringify(prevState.valueFormat)) return null
        return {
            valueFormat: InputFormat.formatNumber(nextProps.value, nextProps.isSeparate, 0, nextProps.allowNegative)
        }
    }


    render() {
        let valueFormat = this.state.valueFormat;
        let className_perfix = this.props.className.split(" ");
        className_perfix = className_perfix.join('-dnx ');
        return (
            <div className={"input-validate " + this.state.error + ' ' + className_perfix + '-dnx'}>
                {!(this.props.isRedstar === false) && <label>*</label>}
                {this.props.addonBefore ? <Input
                    addonBefore={this.props.addonBefore}
                    disabled={this.props.disabled ? true : false}
                    onChange={e => this.onChange(e.target.value)}
                    value={valueFormat}
                    placeholder={this.props.placeholder}
                    onBlur={e => this.onBlur(e.target.value)}
                    onFocus={e => this.onFocus(e.target.value)}
                    className={this.props.className ? this.props.className : ''}
                    autoFocus={this.props.autoFocus}
                /> : <Input
                        disabled={this.props.disabled ? true : false}
                        onChange={e => this.onChange(e.target.value)}
                        value={valueFormat}
                        placeholder={this.props.placeholder}
                        onBlur={e => this.onBlur(e.target.value)}
                        onFocus={e => this.onFocus(e.target.value)}
                        onClick={e => this.onClick(e.target.value)}
                        className={this.props.className ? this.props.className : ''}
                        onFocus={e => this.onFocus(e.target.value)}
                        autoFocus={this.props.autoFocus}
                    />}
            </div>
        );
    }

    onChange = (value) => {
        let decimal = this.props.decimal;
        let isSeparate = this.props.isSeparate;
        let valueParser = InputFormat.parserNumber(value).toString();
        let valuePublic = valueParser;
        let self = this;
        if (decimal) {
            let naturalPart;
            let decimalFraction;
            let config = configNumber()
            let floatPoint = config[1]
            if (valueParser.lastIndexOf(floatPoint) !== -1) {
                let number_array = valueParser.split(floatPoint)
                naturalPart = number_array[0];
                decimalFraction = number_array[1];
                if (naturalPart.length > decimal[0])
                    return

                if (decimalFraction && decimalFraction.length > decimal[1])
                    return
            }
            else {
                if (valueParser.length > decimal[0])
                    return
            }
        }

        const valueFormat = InputFormat.formatNumber(valueParser, isSeparate)
        this.setState({
            ...this.state,
            valueFormat,
            valuePublic: Number(InputFormat.parserNumber(valueParser))
        })
        self.props.onChange(valuePublic, valueFormat)
    }

    onFocus = (value) => {
        let state = this.state
        if (this.props.validate && this.props.validate === 'icon') {
            state.error = ''
        }

        if ((this.props.defaultValue && value === this.props.defaultValue)) {
            state.valueFormat = ''
        }

        if ((this.props.isZero && value === 0)) {
            state.valueFormat = ''
        }

        if (this.props.onFocus) {
            this.props.onFocus(value)
        }

        this.setState(state);
    }

    onClick = (value) => {
        if (this.props.onClick) {
            this.props.onClick(value)
        }
    }

    onBlur = (value) => {
        let self = this;
        let min = this.props.min ? this.props.min : undefined;
        if (value && !this.state.prefixIsZero) {
            value = Number(InputFormat.parserNumber(value));
        }

        let state = this.state;
        if (!isNaN(value)) {
            state.valueFormat = InputFormat.parserNumber(value, this.props.decimal, this.props.isSeparate);
        }
        if ((this.props.defaultValue || this.props.defaultValue === 0) && !value) {
            state.valueFormat = this.props.defaultValue
            value = this.props.defaultValue
        }
        if ((this.props.isZero && value === 0)) {
            state.error = 'input-validate-error'
        }

        if ((this.props.isZero && value === 0)) {
            state.valueFormat = ''
        } else {
            state.valueFormat = value
        }

        if (this.props.validate && this.props.validate === 'icon') {
            if (min) {
                if (value === null || value === '' || value === undefined || value < min) {
                    state.error = 'input-validate-error'
                }
            }
            else {
                if (value === null || value === '' || value === undefined) {
                    state.error = 'input-validate-error'
                }
            }
        }

        this.setState(state, () => {
            self.props.onChange(value)
            if (self.props.onBlur)
                self.props.onBlur(value)
        });
    }

    /**
     *
     * @param {number} number
     * @param {boolean} isSeparate
     * @param {int} decimalFractionLength number of digits after float point : số chữ số sau dấu thập phân
     */
    static formatNumber(number, isSeparate, decimalFractionLength = 0, isAllowNegative = false) {
        if (number === 0) {
            return 0
        }

        if (!number) {
            return '';
        } else {
            number = number.toString();
            let config = configNumber();
            let floatPoint = config[1];
            let separate = ''
            if (isSeparate) {
                separate = config[0];
            }
            let symNeg = '';
            if (isAllowNegative && number[0] === '-') { // check number is negative and is allow negagative
                symNeg = '-';
            }
            /**
             * regex not float point and not numeric
             */
            let regex = new RegExp('[^' + floatPoint + '\\d]', 'g');
            let number_string = number.replace(regex, '').toString();
            let number_array = number_string.split(floatPoint)
            let naturalPart = number_array[0];
            let decimalFraction = number_array[1];
            let rest = naturalPart.length % 3;
            let result = naturalPart.substr(0, rest);
            let thousands = naturalPart.substr(rest).match(/\d{3}/g);

            if (thousands) {
                const separator = rest ? separate : '';
                result += separator + thousands.join(separate);
            }

            result = decimalFraction !== undefined ? result + floatPoint + decimalFraction : result;
            return symNeg + result;
        }
    }

    static parserNumber(value) {
        if (!value) {
            value = ''
        }
        let config = configNumber();
        let regex = new RegExp(config[0], 'g')
        value = value.toString().replace(regex, '');
        return value;
    }

    getValue = (value) => {
        return this.parserNumber(value);
    }

    isValid = () => {
        let min = this.props.min ? this.props.min : undefined;
        if ((this.props.validate && this.props.validate === 'icon')) {
            if (min) {
                if (this.state.valueFormat === null || this.state.valueFormat === '' || this.state.valueFormat === undefined || this.state.valueFormat < min) {
                    this.setState({
                        error: 'input-validate-error'
                    })
                    return false
                }
            }
            else {
                if (this.state.valueFormat === null || this.state.valueFormat === '' || this.state.valueFormat === undefined) {
                    this.setState({
                        error: 'input-validate-error'
                    })
                    return false
                }
            }
        }
        if (this.props.isZero && this.state.valueFormat === 0) {
            this.setState({
                error: 'input-validate-error'
            })
            return false
        } return true
    }

}

const configNumber = () => {
    let locale = getLocale();
    switch (locale) {
        case "en":
            return [",", "."];
        default:
            return [",", "."];
    }
}

const getLocale = () => {
    return "en";
}

export default InputFormat



// WEBPACK FOOTER //
// ./src/components/input-format/index.js